import React from 'react';
import { Star } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function HeroSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="relative pt-12 pb-0 px-4 md:pt-20 md:pb-0 overflow-hidden bg-gradient-to-b from-[#E8F4FD] to-white" data-id="element-93">
      {/* Decorative Background Elements */}
      <div className="absolute top-10 left-10 text-blue-200 opacity-50 animate-bounce delay-700" data-id="element-94">
        <Star className="w-12 h-12" fill="currentColor" data-id="element-95" />
      </div>
      <div className="absolute top-20 right-10 text-yellow-200 opacity-50 animate-pulse" data-id="element-96">
        <Star className="w-8 h-8" fill="currentColor" data-id="element-97" />
      </div>

      <div ref={ref} className={`max-w-4xl mx-auto text-center ${isVisible ? 'reveal-visible' : 'reveal-hidden'}`} data-id="element-98">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#333333] mb-6 leading-tight" data-id="element-99">
          Tu hijo aprenderá a leer en{' '}
          <span className="text-[#4A90D9]" style={{
          fontWeight: '700',
          color: '#ff8c42'
        }} data-id="element-100">
            14 días
          </span>{' '}
          sin trabarse
        </h1>
      </div>

      {/* Hero Image */}
      <div className="mt-8 max-w-6xl mx-auto relative" data-id="element-101">
        <img src="https://cdn.magicpatterns.com/uploads/hyGSDgF8CiC1YBJRLFoPMV/Diseno_sin_titulo.png" alt="MegaKit Lectura Feliz - Más de 100 actividades divertidas" className="w-full h-auto drop-shadow-2xl" data-id="element-102" />

        {/* Floating elements */}
        <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-2xl shadow-xl border border-gray-100 hidden md:block animate-bounce" style={{
        animationDuration: '3s'
      }} data-id="element-103">
          <div className="flex items-center gap-2" data-id="element-104">
            <div className="text-yellow-400" data-id="element-105">★★★★★</div>
            <span className="font-bold text-gray-700" data-id="element-106">4.9/5</span>
          </div>
        </div>
      </div>

      {/* CTA Button - below image */}
      <div className="mt-12 flex flex-col items-center" data-id="element-107"></div>
    </section>;
}